import { Repository } from "src/firebase/firestore/repository";
import { AiScenario } from "./entities/ai-scenario.entity";

class AiScenarioRepository extends Repository<AiScenario> {
  constructor() {
    super("custom_ai_scenario");
  }

  async findById(id: string): Promise<AiScenario | null> {
    return (await super.findById(id)) as AiScenario | null;
  }

  async find(args: any): Promise<(AiScenario & { id: string })[]> {
    return (await super.find(args)) as (AiScenario & { id: string })[];
  }

  async count(where?: any): Promise<number> {
    return await super.count(where);
  }
}

export const aiScenarioRepository = new AiScenarioRepository();
